"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NUMBER_FORMAT_TYPE = void 0;
var NUMBER_FORMAT_TYPE;
(function (NUMBER_FORMAT_TYPE) {
    // NUMBER_FORMAT_TYPE_UNSPECIFIED,
    NUMBER_FORMAT_TYPE["GENERAL"] = "auto";
    NUMBER_FORMAT_TYPE["TEXT"] = "text";
    NUMBER_FORMAT_TYPE["NUMBER"] = "number";
    NUMBER_FORMAT_TYPE["PERCENT"] = "percent";
    NUMBER_FORMAT_TYPE["CURRENCY"] = "currency";
    NUMBER_FORMAT_TYPE["DATE"] = "date";
    NUMBER_FORMAT_TYPE["TIME"] = "time";
    NUMBER_FORMAT_TYPE["DATE_TIME"] = "date-time";
    NUMBER_FORMAT_TYPE["FRACTION"] = "fraction";
    NUMBER_FORMAT_TYPE["SCIENTIFIC"] = "scientific";
    NUMBER_FORMAT_TYPE["ACCOUNTING"] = "accounting";
    NUMBER_FORMAT_TYPE["SPECIAL"] = "special";
    NUMBER_FORMAT_TYPE["CUSTOM"] = "custom";
})(NUMBER_FORMAT_TYPE = exports.NUMBER_FORMAT_TYPE || (exports.NUMBER_FORMAT_TYPE = {}));
//# sourceMappingURL=NumberFormatType.js.map